export enum CreditLineRequestStatus {
    Pending = 'pending',
    InReview = 'in-review',
    ManualReview = 'manual-review',
    Blocked = 'blocked',
    Declined = 'declined',
    Approved = 'approved',
    Canceled = 'canceled',
    Preapproved = 'preapproved',
}
